module.exports = __webpack_public_path__ + "sunsemweb/img/culture.88dd12a2.png";